import { render, staticRenderFns } from "./BookShopManage.vue?vue&type=template&id=4aa9fb7c&scoped=true"
import script from "./BookShopManage.vue?vue&type=script&lang=js"
export * from "./BookShopManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa9fb7c",
  null
  
)

export default component.exports